import { getPenaltyCardColumns } from "./PenaltyCard.config";

import PenaltyCard from "./PenaltyCard";

const PenaltyCardContainer = ({ items }: any) => {
  const columns = getPenaltyCardColumns();

  if (items.length <= 1) {
    return null;
  }

  return <PenaltyCard items={items} columns={columns} />;
};

export default PenaltyCardContainer;
